import Joi from 'joi';

export const profileAmendmentRequestSchema = Joi.object({
  status: Joi.object().required().messages({
    'any.required': 'Please select request status',
  }),
  remarks: Joi.string().allow(''),
});
